import axios from "axios";
import React, { useEffect, useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  percentageValidation,
  showMessage,
} from "../../Functionalities/Functions";
import MapView from "./MapView";
import AddTopComponent from "../../CoreComponents/AddTopComponent";
import AddBottomComponent from "../../CoreComponents/AddBottomComponent";
import { googleApiKey } from "../../Functionalities/Config";
import { ManageFranchise, ManageSettingsAdmin } from "./Logic";
import RestaurantAreaField from "./RestaurantAreaField";

function Body() {
  const [disable, setdisable] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    id: "",
    place: "",
    is_featured: false,
    managers: [],
    admin: [],

    commission: 0,
    restaurants_within_radius: "",

    keyword: "",
    franchise_id: "",

    franchise_name: "",
    place: "",
    latitude: "",
    longitude: "",
    address: "",
    mobile: "",
    description: "",

    // admin_name:"",
    // admin_username:"",
    // admin_password:"",
    // admin_mobile:"",

    // managers_list:[],
  });
  const [apiKey, setapiKey] = useState("");
  useEffect(() => {
    getApiKey();
  });
  const [admins, setAdmins] = useState({
    admin_name: "",
    admin_username: "",
    admin_password: "",
    confirm_admin_password: "",
    admin_mobile: "",
  });
  const [manager, setManager] = useState({
    id: "",
    manager_name: "",
    manager_username: "",
    manager_password: "",
    manager_mobile: "",
  });

  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [address, setAddress] = useState("");
  const getApiKey = () => {
    let res = ManageSettingsAdmin(
      "",
      "",
      "get",
      "param_name=googlemap_key&keyword=super_admin_conf"
    );
    res.then((result) => {
      if (result?.data?.Message?.param_value && result.data.Message.param_value !== "XXXXXXXXXXXXXX") {
        setapiKey(result.data.Message.param_value);
      } else {
      }
    });
  };

  const handleCoordinatesChange = (latt, longi) => {
    setLatitude(latt);
    setLongitude(longi);

    const locToPlace = (lat, long) => {
      // var url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + long + `&key=${googleApiKey}&sensor=true`;
      var url =
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        lat +
        "," +
        long +
        `&key=${apiKey ? apiKey : googleApiKey}&sensor=true`;
      axios
        .get(url)
        .then(function (response) {
          // setData({ ...data, address: response.data.results[0].formatted_address, latitude: latt, longitude: longi })
          setAddress(response.data.results[0].formatted_address);
        })
        .catch(function (error) {
          // void 0
        });
    };
    locToPlace(latt, longi);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      // void 0
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setData(prev => ({ ...prev, address: address }));
  }, [address]);

  useEffect(() => {
    setData(prev => ({ ...prev, latitude: latitude }));
  }, [latitude]);

  useEffect(() => {
    setData(prev => ({ ...prev, longitude: longitude }));
  }, [longitude]);

  // void 0

  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (errors.length > 0) {
      showMessage(
        errors[0],
        "danger",
        "Following fields required!",
        "top",
        "top-right",
        0
      );
    }
  }, [errors]);

  return (
    <div>
      <div class="content-body">
        <div class="container-fluid">
          <AddTopComponent path={"franchises"} />

          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="basic-form">
                  <form>
                    <div className="card-header">
                      <h4 className="card-title">Franchise Admin</h4>
                    </div>
                    <div className="card-body">
                      <div className="basic-form">
                        <div className="form-row">
                          <div className="form-group col-md-6">
                            <label>
                              Name <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={admins.admin_name}
                              onChange={(e) => {
                                setAdmins({
                                  ...admins,
                                  admin_name: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>
                              Username <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={admins.admin_username}
                              onChange={(e) => {
                                setAdmins({
                                  ...admins,
                                  admin_username: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>
                              Password <span className="required">*</span>
                            </label>
                            <input
                              type="password"
                              className="form-control"
                              value={admins.admin_password}
                              onChange={(e) => {
                                setAdmins({
                                  ...admins,
                                  admin_password: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>
                              Confirm Password{" "}
                              <span className="required">*</span>
                            </label>
                            <input
                              type="password"
                              className="form-control"
                              value={admins.confirm_admin_password}
                              onChange={(e) => {
                                setAdmins({
                                  ...admins,
                                  confirm_admin_password: e.target.value,
                                });
                              }}
                            />
                          </div>

                          <div className="form-group col-md-6">
                            <label>
                              Mobile <span className="required">*</span>
                            </label>
                            <input
                              type="number"
                              pattern="[0-9]*"
                              min={0}
                              className="form-control"
                              onKeyDown={(evt) =>
                                ((evt.key === "e" || evt.key === "-") &&
                                  evt.preventDefault()) ||
                                (evt.key === "E" && evt.preventDefault())
                              }
                              onWheelCapture={(e) => {
                                e.target.blur();
                              }}
                              value={admins.admin_mobile}
                              onChange={(e) => {
                                setAdmins({
                                  ...admins,
                                  admin_mobile: e.target.value.slice(0, 10),
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-header">
                      <h4 className="card-title">Franchise Details</h4>
                    </div>
                    <br></br>
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Franchise name <span className="required">*</span>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          value={data.franchise_name}
                          onChange={(e) =>
                            setData(prev => ({ ...prev, franchise_name: e.target.value }))
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Mobile <span className="required">*</span>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          value={data.mobile}
                          onKeyDown={(evt) =>
                            ((evt.key === "e" || evt.key === "-") &&
                              evt.preventDefault()) ||
                            (evt.key === "E" && evt.preventDefault())
                          }
                          onWheelCapture={(e) => {
                            e.target.blur();
                          }}
                          onChange={(e) =>
                            setData(prev => ({
                              ...prev,
                              mobile: e.target.value.slice(0, 10),
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Commission in % <span className="required">*</span>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          value={data.commission}
                          onKeyDown={(evt) =>
                            ((evt.key === "e" || evt.key === "-") &&
                              evt.preventDefault()) ||
                            (evt.key === "E" && evt.preventDefault())
                          }
                          onWheelCapture={(e) => {
                            e.target.blur();
                          }}
                          onChange={(e) =>
                            e.target.value >= 100
                              ? showMessage(
                                  "Commission should be less than 100",
                                  "danger",
                                  "Error!",
                                  "top",
                                  "top-right"
                                )
                              : setData(prev => ({ ...prev, commission: e.target.value }))
                          }
                        />
                      </div>
                    </div>
                    <RestaurantAreaField
                      value={data.restaurants_within_radius}
                      onChange={(restaurants_within_radius) => setData((prev) => ({ ...prev, restaurants_within_radius }))}
                    />

                    {!loading && apiKey !== "" ? (
                      <div
                        style={{
                          marginBottom: 20,
                          border: "1px solid #69ff76",
                          padding: 10,
                          borderRadius: 20,
                        }}
                      >
                        <MapView onChange={handleCoordinatesChange} />
                      </div>
                    ) : (
                      <div>
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Latitude <span className="required">*</span>
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              value={latitude}
                              onChange={(e) => setLatitude(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Longitude <span className="required">*</span>
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              value={longitude}
                              onChange={(e) => setLongitude(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Address <span className="required">*</span>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          value={data.address}
                          onChange={(e) =>
                            setData(prev => ({ ...prev, address: e.target.value }))
                          }
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Description
                      </label>
                      <div class="col-sm-9">
                        <textarea
                          class="form-control"
                          rows="4"
                          id="comment"
                          value={data.description}
                          onChange={(e) => {
                            setData(prev => ({ ...prev, description: e.target.value }));
                          }}
                        ></textarea>
                      </div>
                    </div>
                    <br />
                    <br></br>
                    <div className="text-center">
                      <div className="form-group column">
                        <a
                          data-toggle="modal"
                          data-target="#sendMessageModal"
                          href=""
                        >
                          <span
                            style={{ marginRight: 10 }}
                            className="item badge badge-circle badge-success "
                          >
                            <i class="ti-plus"></i>
                          </span>
                          Add Managers
                        </a>

                        <div className="modal fade" id="sendMessageModal">
                          <div
                            className="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Add Managers</h5>
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="modal"
                                >
                                  <span>×</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <form className="comment-form">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Name
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={manager.manager_name}
                                          onChange={(e) => {
                                            setManager({
                                              ...manager,
                                              manager_name: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Username
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={manager.manager_username}
                                          onChange={(e) => {
                                            setManager({
                                              ...manager,
                                              manager_username: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Password
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="password"
                                          className="form-control"
                                          value={manager.manager_password}
                                          onChange={(e) => {
                                            setManager({
                                              ...manager,
                                              manager_password: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Confirm Password
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="password"
                                          className="form-control"
                                          value={
                                            manager.confirm_manager_password
                                          }
                                          onChange={(e) => {
                                            setManager({
                                              ...manager,
                                              confirm_manager_password:
                                                e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Phone{" "}
                                          <span className="required">*</span>{" "}
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={manager.manager_mobile}
                                          onKeyDown={(evt) =>
                                            ((evt.key === "e" ||
                                              evt.key === "-") &&
                                              evt.preventDefault()) ||
                                            (evt.key === "E" &&
                                              evt.preventDefault())
                                          }
                                          onWheelCapture={(e) => {
                                            e.target.blur();
                                          }}
                                          onChange={(e) => {
                                            setManager({
                                              ...manager,
                                              manager_mobile:
                                                e.target.value.slice(0, 10),
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-12">
                                      <div className="form-group mb-0 text-center">
                                        {/* <button type="button" className="close">
                                                                                    <span>×</span>
                                                                                </button> */}
                                        <button
                                          type="submit"
                                          data-dismiss="modal"
                                          style={{ marginRight: 5 }}
                                          //data-dismiss="modal"
                                          className="submit btn btn-primary"
                                          onClick={(e) => {
                                            e.preventDefault();

                                            setManager({
                                              id: "",
                                              manager_name: "",
                                              manager_username: "",
                                              manager_password: "",
                                              manager_mobile: "",
                                              confirm_manager_password: "",
                                            });
                                          }}
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          type="submit"
                                          data-dismiss={"modal"}
                                          style={{ marginRight: 5 }}
                                          //data-dismiss="modal"
                                          className="submit btn btn-primary"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            // MANAGER VALIDATION
                                            setErrors([]);
                                            if (manager.manager_name === "") {
                                              setErrors(["Manager name"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_username === ""
                                            ) {
                                              setErrors(["Manager username"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_password === ""
                                            ) {
                                              setErrors(["Manager password"]);
                                              return;
                                            }
                                            // void 0

                                            if (
                                              manager.manager_password.length <
                                              5
                                            ) {
                                              setErrors([
                                                "Password must be more than 5 characters",
                                              ]);
                                              return;
                                            }
                                            if (
                                              manager.confirm_manager_password ===
                                              ""
                                            ) {
                                              setErrors([
                                                "Manager confirm password",
                                              ]);
                                              return;
                                            }
                                            if (
                                              manager.manager_password !==
                                              manager.confirm_manager_password
                                            ) {
                                              setErrors([
                                                "Manager confirm password not match",
                                              ]);
                                              return;
                                            }
                                            if (manager.manager_mobile === "") {
                                              setErrors(["Manager mobile"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_mobile.length < 10
                                            ) {
                                              setErrors([
                                                "Manager mobile invalid",
                                              ]);
                                              return;
                                            }

                                            setData(prev => ({
                                              ...prev,
                                              managers: [
                                                ...prev.managers,
                                                { ...manager, id: Date.now() },
                                              ],
                                            }));
                                            setManager({
                                              id: "",
                                              manager_name: "",
                                              manager_username: "",
                                              manager_password: "",
                                              manager_mobile: "",
                                              confirm_manager_password: "",
                                            });
                                            showMessage(
                                              "Manager added!",
                                              "success",
                                              "Success!",
                                              "top",
                                              "top-right",
                                              0
                                            );
                                          }}
                                        >
                                          Submit and close
                                        </button>
                                        <button
                                          //data-dismiss="modal"
                                          className="submit btn btn-primary"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setErrors([]);
                                            if (manager.manager_name === "") {
                                              setErrors(["Manager name"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_username === ""
                                            ) {
                                              setErrors(["Manager username"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_password === ""
                                            ) {
                                              setErrors(["Manager password"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_password.length <
                                              5
                                            ) {
                                              setErrors([
                                                "Password must be more than 5 characters",
                                              ]);
                                              return;
                                            }
                                            if (
                                              manager.confirm_manager_password ===
                                              ""
                                            ) {
                                              setErrors([
                                                "Manager confirm password",
                                              ]);
                                              return;
                                            }

                                            if (
                                              manager.manager_password !==
                                              manager.confirm_manager_password
                                            ) {
                                              setErrors([
                                                "Manager confirm password not match",
                                              ]);
                                              return;
                                            }
                                            if (manager.manager_mobile === "") {
                                              setErrors(["Manager mobile"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_mobile.length < 10
                                            ) {
                                              setErrors([
                                                "Manager mobile invalid",
                                              ]);
                                              return;
                                            }
                                            setData(prev => ({
                                              ...prev,
                                              managers: [
                                                ...prev.managers,
                                                { ...manager, id: Date.now() },
                                              ],
                                            }));
                                            setManager({
                                              id: "",
                                              manager_name: "",
                                              manager_username: "",
                                              manager_password: "",
                                              manager_mobile: "",
                                              confirm_manager_password: "",
                                            });
                                            showMessage(
                                              "Manager added!",
                                              "success",
                                              "Success!",
                                              "top",
                                              "top-right",
                                              0
                                            );
                                          }}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {data.managers.length > 0 &&
                        data.managers.map((man) => {
                          return (
                            <p>
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  setData(prev => ({
                                    ...prev,
                                    managers: prev.managers.filter(
                                      (var_item) => var_item.id !== man.id
                                    ),
                                  }));
                                  showMessage(
                                    "Manager removed!",
                                    "success",
                                    "Success!",
                                    "top",
                                    "top-right",
                                    0
                                  );
                                }}
                                className="btn mr-2"
                                style={{ color: "red" }}
                                href=""
                              >
                                <span className="item">
                                  <i class="ti-trash"></i>
                                </span>
                              </a>{" "}
                              firstname : {man.manager_name} - Username :{" "}
                              {man.manager_username} - Mobile :{" "}
                              {man.manager_mobile}
                            </p>
                          );
                        })}
                    </div>
                    <AddBottomComponent
                      disable={disable}
                      saveButton={(e) => {
                        e.preventDefault();
                        setdisable(true);
                        setErrors([]);

                        // FRANCHISE VALIDATION
                        if (admins.admin_name === "") {
                          setdisable(false);
                          setErrors(["Admin name"]);
                          return;
                        }
                        if (admins.admin_username === "") {
                          setdisable(false);
                          setErrors(["Admin username"]);
                          return;
                        }
                        if (admins.admin_password === "") {
                          setdisable(false);
                          setErrors(["Admin password"]);
                          return;
                        }
                        if (admins.admin_password.length < 5) {
                          setdisable(false);
                          setErrors([
                            "Password must be more than 5 characters",
                          ]);
                          return;
                        }
                        if (admins.confirm_admin_password === "") {
                          setdisable(false);
                          setErrors(["Admin confirm password"]);
                          return;
                        }
                        if (
                          admins.admin_password !==
                          admins.confirm_admin_password
                        ) {
                          setdisable(false);
                          setErrors(["Admin password mismatch"]);
                          return;
                        }
                        if (admins.admin_mobile === "") {
                          setdisable(false);
                          setErrors(["Admin mobile"]);
                          return;
                        }
                        if (admins.admin_mobile.length < 10) {
                          setdisable(false);
                          setErrors(["Admin Mobile number must be 10 number"]);
                          return;
                        }

                        if (data.franchise_name === "") {
                          setdisable(false);
                          setErrors(["Franchise name"]);
                          return;
                        }
                        if (data.mobile === "") {
                          setdisable(false);
                          setErrors(["Franchise mobile"]);
                          return;
                        }
                        if (data.mobile.length < 10) {
                          setdisable(false);
                          setErrors(["Mobile number must be 10 number"]);
                          return;
                        }
                        if (data.latitude === "") {
                          setdisable(false);
                          setErrors(["Pick location from Map"]);
                          return;
                        }
                        if (data.longitude === "") {
                          setdisable(false);
                          setErrors(["Pick location from Map"]);
                          return;
                        }
                        if (data.address === "") {
                          setdisable(false);
                          setErrors(["Address"]);
                          return;
                        }

                        let data_obj = {
                          ...data,
                          admin: [...data.admin, admins],
                        };

                        let res = ManageFranchise(e, data_obj, "add", "");

                        res
                          .then((res) => {
                            setdisable(false);
                            if (res.data.Status === true) {
                              showMessage(
                                "Franchise successfully added!",
                                "success",
                                "Success!",
                                "top",
                                "top-right",
                                0
                              );
                              setData({
                                id: "",
                                franchise_name: "",
                                mobile: "",
                                email: "",
                                fssai: "",
                                place: "",
                                latitude: "",
                                longitude: "",
                                address: "",
                                description: "",
                                is_featured: false,
                                images: [],
                                managers: [],
                                admin: [],
                                commission: 0,
                                restaurants_within_radius: "",
                              });
                              setAdmins({
                                admin_name: "",
                                admin_username: "",
                                admin_password: "",
                                admin_mobile: "",
                                confirm_admin_password: "",
                              });
                              setAddress("");
                              setLatitude("");
                              setLongitude("");
                              window.scrollTo(0, 0);
                            } else {
                              showMessage(
                                res.data.Error,
                                "danger",
                                "Failed!",
                                "top",
                                "top-right",
                                0
                              );
                              if (res.data.rejected) {
                                for (
                                  var i = 0;
                                  i < res.data.rejected.length;
                                  i++
                                ) {
                                  if (res.data.rejected[i].error) {
                                    showMessage(
                                      res.data.rejected[i].manager_name +
                                        " : " +
                                        res.data.rejected[i].error,
                                      "danger",
                                      "Failed!",
                                      "top",
                                      "top-right",
                                      0
                                    );
                                  }
                                }
                              } else {
                                showMessage(
                                  res.data.Error,
                                  "danger",
                                  "Failed!",
                                  "top",
                                  "top-right",
                                  0
                                );
                              }
                            }
                          })
                          .catch((err) => {
                            setdisable(false);

                          });
                      }}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function AddFranchise() {
  const headers = "Create Franchise";
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default AddFranchise;
